const Config = {
    appApiUrl: process.env.REACT_APP_API_URL,
    enableLog: false,
    sessionTimeout: 3600000, // one hour = 3600 000 ms
}

export default Config;